import React, {FC} from 'react';
import ThCustom from "@ui/tableCustom/view/ui/thCustom/ThCustom";
import TrCustom from "@ui/tableCustom/view/ui/trCustom/TrCustom";
import ButtonToggleRowExport
	from "@containers/export/containers/buildData/view/buttons/buttonToggleRowExport/ButtonToggleRowExport";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {ITableFeaturesRowProps} from "@ui/tableCustom/types/table";
import {Stack} from "@mui/material";
import {sx} from './sx'
import ActionBarTaskTableSingleVoyage from "./actionBar/ActionBarTaskTableSingleVoyage";
import {
	SubTaskSingleVoyageTransformForTable,
	TaskSingleVoyageTransformForTable,
	TaskWayPointSingleVoyage
} from "@containers/singleVoyage/tasks/table/types";
import {OnDeleteTaskSingleVoyage, OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import CurrentValueItemTableTaskSingleVoyage
	from "@containers/singleVoyage/tasks/table/item/currentValue/CurrentValueItemTableTaskSingleVoyage";
import TasksFilesListModalSingleVoyage
	from "@containers/singleVoyage/tasks/tasksFiles/tasksFilesList/TasksFilesListModalSingleVoyage";
import TableRowSubTasksSingleVoyage
	from "@containers/singleVoyage/tasks/table/item/subTasks/TableRowSubTasksSingleVoyage";

interface IProps extends ITableFeaturesRowProps<TaskSingleVoyageTransformForTable> {
	fullColumns: IColumnItem<TaskSingleVoyageTransformForTable>[]
	subtasksFullColumns: IColumnItem<SubTaskSingleVoyageTransformForTable>[]
	onSave?: OnSaveTaskSingleVoyage
	voyageId: number
	waypoints: TaskWayPointSingleVoyage[]
	onDelete?: OnDeleteTaskSingleVoyage
	accountId: string | number
}

const ItemTableTaskSingleVoyage: FC<IProps> = ({
												   content,
												   exportFeaturesProps,
												   fullColumns,
												   onSave,
												   voyageId,
												   waypoints,
												   onDelete,
												   accountId,
												   subtasksFullColumns,
											   }) => {
	
	const list = fullColumns?.map((item, index) => {
		if (index === 0) {
			return (
				<ThCustom
					key={index}
				>
					<Stack
						direction={'row'}
						alignItems={'center'}
						justifyContent={'flex-start'}
						gap={'10px'}
						sx={sx.inner}
					>
						
						<ButtonToggleRowExport
							exportFeaturesProps={exportFeaturesProps}
							id={content.id}
						/>
						
						{content?.files?.length >= 1 && <TasksFilesListModalSingleVoyage
                            files={content.files}
                        />}
						{!exportFeaturesProps?.exportMode && <ActionBarTaskTableSingleVoyage
                            initial={content}
                            onSave={onSave}
                            voyageId={voyageId}
                            waypoints={waypoints}
                            onDelete={onDelete}
                            accountId={accountId}
                        />}
						
						<CurrentValueItemTableTaskSingleVoyage
							content={content}
							column={item}
						
						/>
					</Stack>
				</ThCustom>
			)
		}
		return (
			<ThCustom
				key={index}
			>
				<CurrentValueItemTableTaskSingleVoyage
					content={content}
					column={item}
				/>
			</ThCustom>
		)
	})
	
	return (
		<>
			<TrCustom>
				{list}
			</TrCustom>
			
			{content?.subtasks?.length >= 1 && <TableRowSubTasksSingleVoyage
                subtasks={content.subtasks}
                fullColumns={subtasksFullColumns}
                parent={content}
                onSave={onSave}
                voyageId={voyageId}
                waypoints={waypoints}
                accountId={accountId}
            />}
		</>
	);
};

export default ItemTableTaskSingleVoyage;
